import axios from '../../axios';

export default {
  namespaced: true,
  state: {
    // allRegionPlaces: null,
    // allRegionMaps: null
  },
  getters: {
    // allRegionPlaces: (state) => {
    //  if (state.allRegionPlaces) {
    //    return state.allRegionPlaces
    //  }
    // },
    allRegionMaps: (state, getters, rootState, rootGetters) => {
      if (rootGetters['regions/allRegions']) {
        const regionMaps = [];
        rootGetters['regions/allRegions'].filter((r) => r.subRegions && r.subRegions.length > 0).forEach((sr, key) => {
          sr.subRegions.forEach((rp, key2) => {
            regionMaps.push(...rp.regionPlaces);
          });
        });
        return regionMaps;
      }
    },
    regionMapByCountryId: (state, getters, rootState, rootGetters) => (id) => {
      if (getters.allRegionMaps) {
        const regionMaps = [];
        // get all regions in country
        rootGetters['regions/allRegions'].filter((r) => r.countryId === id).forEach((r, key) => {
          regionMaps.push(...getters.allRegionMaps.filter((rm) => rm.regionId === r.regionId));
        });
        return regionMaps;
      }
    },
    regionMapByRegionId: (state, getters, rootState, rootGetters) => (id) => {
      if (getters.allRegionMaps) {
        return getters.allRegionMaps.filter((rm) => rm.regionId === id);
      }
    },
    regionMapBySubRegionId: (state, getters, rootState, rootGetters) => (id) => {
      if (getters.allRegionMaps) {
        return getters.allRegionMaps.filter((rm) => rm.regionSubId === id);
      }
    },
    // regionPlacesByRegionId: (state) => (id) => {
    //  if (state.allRegionPlaces) {
    //    return state.allRegionPlaces.filter(r => { return r.regionId === id })
    //  }
    // }
  },
  mutations: {
    // setAllRegionPlaces(state, regionPlaces) {
    //  state.allRegionPlaces = regionPlaces
    // },
    // setAllRegionMaps(state, regionMaps) {
    //  state.allRegionMaps = regionMaps
    // }
  },
  actions: {
    // fetchAllRegionPlaces({ commit }) {
    //  return new Promise((resolve, reject) => {
    //    axios.get('/core/regionplaces').then(res => {
    //      commit('setAllRegionPlaces', res.data)
    //      return resolve(res)
    //    }).catch(error => reject(error))
    //  })
    // },
    // fetchAllRegionMaps({ commit }) {
    //  return new Promise((resolve, reject) => {
    //    axios.get('/core/regionplaces/maps').then(res => {
    //      commit('setAllRegionMaps', res.data)
    //      return resolve(res)
    //    }).catch(error => reject(error))
    //  })
    // },
  },
};
